import * as React from 'react';
import {WorkerSelect} from './worker/WorkerSelect';
import {withRouter} from 'react-router';
import {Direction} from '../../models/enums/Direction';

export const SignIn = withRouter(({history}) => {
    return <WorkerSelect direction={Direction.ENTRY} history={history}/>;
});
